import { Context } from '@nuxt/types'

export default async function ({ $seo }: Context) {
  try {
    process.client ? $seo.seoMiddleware() : await $seo.seoMiddleware()
  } catch (error) {
    console.error(error)
  }
}
